import {
    SET_APP_START,
    LOADING,
    AUTH_FORM,
    REGISTRATION_FORM,
    BOOKING,
    RECOVERY_PASSWORD_FORM,
    CHECK_EMAIL_FORM,
    FILTERS,
    EST,
    SET_USER_BAR,
    SET_USER,
    SET_SUBSCRIPTIONS,
    SET_SCHEDULE,
    SET_SCHEDULE_ACTIVE,
    SET_MY_RESERVES
} from "./types";

// Загрузка приложения
export const setAppStartAction = data => ({ type: SET_APP_START, data });
// Состояние загрузки
export const loadingAction = data => ({ type: LOADING, data });
// Форма авторизации
export const authAction = data => ({ type: AUTH_FORM, data });
// Форма регистрации
export const registrationAction = data => ({ type: REGISTRATION_FORM, data });
// Форма восстановления пароля
export const recoveryPasswordAction = data => ({ type: RECOVERY_PASSWORD_FORM, data });
// Форма проверки кода из письма
export const checkEmailFormAction = data => ({ type: CHECK_EMAIL_FORM, data });
// Записи на групповые занятия
export const bookingAction = data => ({ type: BOOKING, data });
// Фильтры
export const filtersAction = data => ({ type: FILTERS, data });
// Параметры заведения для iframe
export const estAction = data => ({ type: EST, data });
// Боковое меню пользователя
export const setUserBarAction = data => ({ type: SET_USER_BAR, data });
// Данные пользователя
export const setUserAction = data => ({ type: SET_USER, data });
// Абонементы пользователя
export const setSubscriptionsAction = data => ({ type: SET_SUBSCRIPTIONS, data });
// Обновление расписания
export const setScheduleAction = data => ({ type: SET_SCHEDULE, data });
// Доступность расписания с услугами
export const setScheduleActiveAction = data => ({ type: SET_SCHEDULE_ACTIVE, data });
// Список записей на услуги
export const setMyReservesAction = data => ({ type: SET_MY_RESERVES, data });